import type { PageProps } from 'gatsby';
import React from 'react';

import ForgotPassword from '@views/Authentication/PasswordReset/EmailForm';

function ForgotPasswordPage({ params }: PageProps) {
  return <ForgotPassword {...params} />;
}

export default ForgotPasswordPage;
